import type { StructuredCommunicationDetails } from '@izimi/api';

import BaseCommunicationDetailsEntity from './BaseCommunicationDetailsEntity';

/**
 * @deprecated Entity classes are being removed. Use the generated `BoxStructuredCommunicationDetails`
 * type from `@fednot/certinot-api` together with the helpers in `communications/helpers.ts`.
 */
class StructuredCommunicationDetailsEntity extends BaseCommunicationDetailsEntity {
  readonly centralisDossierId: string;
  readonly centralisDossierRef: string;
  readonly status: 'open' | 'closed';

  constructor(communicationDetails: StructuredCommunicationDetails, collection?: string) {
    super(communicationDetails, collection);
    this.centralisDossierId = communicationDetails.centralisDossierId;
    this.centralisDossierRef = communicationDetails.centralisDossierRef;
    this.status = communicationDetails.status;
  }
}

export default StructuredCommunicationDetailsEntity;
